import { LIBRARY_URL } from '@/consts/urls';
import { fetchLibraryData } from './utils';

import type { LibraryItem } from '@/types';

type Params = {
  tagId: string;
};

type ResponseType = {
  data: {
    items: LibraryItem[];
  };
};

const getLibrary = async ({ tagId }: Params): Promise<LibraryItem[] | null> => {
  return fetchLibraryData({
    url: `${LIBRARY_URL}/${tagId}/flow`,
    transform: (response) => {
      const data = response as ResponseType;
      return data.data.items?.filter((item) => item.media != null) ?? [];
    },
  });
};

export default getLibrary;
